{
  "page": {
    "title": "Customers",
    "subtitle": "Manage and track all customer records."
  },
  "table": {
    "title": "Customer list",
    "totalCustomers_one": "{{count}} customer",
    "totalCustomers_other": "{{count}} customers",
    "noCustomers": "No customers yet",
    "add": "Add customer",
    "search": "Search name, email, or phone...",
    "filterTags": "Filter by tag",
    "customer": "Customer",
    "email": "Email",
    "phone": "Phone",
    "tags": "Tags",
    "createdAt": "Created",
    "totalItems_one": "{{count}} item",
    "totalItems_other": "{{count}} items",
    "empty": "No customer records found"
  },
  "create": {
    "title": "Add customer",
    "success": "Customer added.",
    "failed": "Could not add the customer.",
    "displayName": "Display name",
    "displayNameRequired": "Enter a display name",
    "displayNameExample": "e.g. Alex Smith",
    "email": "Email",
    "emailInvalid": "Enter a valid email address",
    "phone": "Phone",
    "tags": "Tags",
    "tagsPlaceholder": "Type and press Enter to add a tag",
    "cancel": "Cancel",
    "add": "Add customer"
  },
  "drawer": {
    "editTitle": "Edit customer",
    "title": "Customer details",
    "edit": "Edit",
    "saveSuccess": "Customer saved.",
    "saveFailed": "Could not save the customer.",
    "deleteSuccess": "Customer deleted.",
    "deleteFailed": "Could not delete the customer.",
    "deleteTitle": "Delete this customer?",
    "deleteDetail": "The customer will be hidden. Their conversation and order history will be preserved.",
    "delete": "Delete",
    "deleteCustomer": "Delete customer",
    "cancel": "Cancel",
    "save": "Save",
    "displayName": "Display name",
    "nameRequired": "Enter a name",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Phone",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "selectGender": "Choose gender",
    "birthday": "Date of birth",
    "selectBirthday": "Choose date of birth",
    "tags": "Tags",
    "tagsPlaceholder": "Type and press Enter to add a tag",
    "notes": "Notes",
    "notesPlaceholder": "Additional notes",
    "defaultRecipient": "Default recipient",
    "recipientName": "Recipient name",
    "recipientRequired": "Enter a recipient name",
    "fullName": "Full name",
    "recipientPhone": "Recipient phone",
    "conversations": "Conversations ({{count}})",
    "unnamed": "Unnamed customer"
  },
  "address": {
    "addTitle": "Add address",
    "editTitle": "Edit address",
    "save": "Save",
    "cancel": "Cancel",
    "label": "Address label",
    "labelExample": "e.g. Home, Office",
    "recipientName": "Recipient name",
    "recipientPhone": "Recipient phone",
    "setDefault": "Make default address",
    "default": "Default address",
    "emptyValue": "Address not provided",
    "edit": "Edit address",
    "deleteTitle": "Delete this address?",
    "delete": "Delete address",
    "deleteButton": "Delete",
    "addFailed": "Could not add the address.",
    "addSuccess": "Address added.",
    "editFailed": "Could not edit the address.",
    "editSuccess": "Address updated.",
    "defaultFailed": "Could not set the default address.",
    "defaultSuccess": "Default address updated.",
    "deleteFailed": "Could not delete the address.",
    "deleteSuccess": "Address deleted.",
    "shippingCount": "Shipping addresses ({{count}})",
    "add": "+ Add address",
    "empty": "No shipping addresses yet",
    "houseNumber": "House number",
    "moo": "Moo",
    "village": "Village",
    "room": "Room",
    "floor": "Floor",
    "soi": "Soi",
    "road": "Road",
    "province": "Province",
    "district": "District",
    "subDistrict": "Subdistrict",
    "selectProvince": "Choose province",
    "selectDistrict": "Choose district",
    "selectProvinceFirst": "Choose a province first",
    "selectSubDistrict": "Choose subdistrict",
    "selectDistrictFirst": "Choose a district first",
    "postalCode": "Postal code",
    "postalAuto": "Filled automatically after choosing a subdistrict",
    "country": "Country",
    "previewMoo": "Moo {{value}}",
    "previewSoi": "Soi {{value}}",
    "previewRoad": "Road {{value}}"
  },
  "validation": {
    "phone": "Enter a valid phone number"
  },
  "errors": {
    "load": "Could not load customer records."
  }
}
